/**
 * This takes the `full_slug` string available in Storyblok story object
 * and formats it so it can be used as a pathname.
 * @param fullSlug i.e. 'articles/guides/choosing-a-car/[slug]'
 * @returns An internal pathname string i.e '/guides/choosing-a-car/[slug]'
 */
export const formatFullSlugToPath = (fullSlug: string): string =>
  `/${fullSlug.slice(fullSlug.indexOf('/') + 1)}`
